import { render } from "./RaceEvent.vue?vue&type=template&id=4801fa6a&scoped=true"
import script from "./RaceEvent.vue?vue&type=script&lang=js"
export * from "./RaceEvent.vue?vue&type=script&lang=js"

import "./RaceEvent.vue?vue&type=style&index=0&id=4801fa6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4801fa6a"]])

export default __exports__